import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { IconHelpCircle } from '@rossum/ui/icons/tabler';
import { Link, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { isEmbedded } from '../../../../constants/config';
import { LocalizationKeys } from '../../../../i18n';

type Props = {
  icon: ReactNode;
  localeKey: LocalizationKeys;
  children?: ReactNode;
  helpLink?: string;
};

const TooltipItem = ({ helpLink, icon, localeKey, children }: Props) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1} key={localeKey}>
      {icon}
      <Typography variant="body2">
        <FormattedMessage id={localeKey} />
      </Typography>
      {children}
      {helpLink && !isEmbedded() && (
        <Link
          href={helpLink}
          target="_blank"
          rel="noreferrer noopener"
          sx={{ display: 'flex' }}
        >
          <SvgIcon
            fontSize="medium"
            color="secondary"
            sx={{
              opacity: 0.7,
              '&:hover': {
                opacity: 1,
              },
            }}
          >
            <IconHelpCircle />
          </SvgIcon>
        </Link>
      )}
    </Stack>
  );
};

export default TooltipItem;
